module.exports = __webpack_public_path__ + "img/stackslash-93-mobile.5ddc08a9.jpg";